@if (this.currentUserService.browserOk) {
  <div class="loginout" id="loginout">
    @if (!this.isLoggedIn && !this.loginButtonHidden) {
      <button mat-button class="loginout-text" (click)="logIn()">
        LOG IN
      </button>
    }
    @if (this.isLoggedIn) {
      <div class="loginout-text" [ngClass]="{'impersonating':doingImpersonation()}">
        @if (doingImpersonation()) {
          <div class="impersonation-hello">Hello, {{ currentUserService.user.displayName }}</div>
        }
        @if (this.ShowAppChrome) {
          <div class="person-and-feedback">
            <p class="feedback-text">
              Having an issue?<br />Let us know! <mat-icon style="vertical-align: middle;">forward</mat-icon>
            </p>
            <mat-icon class="feedback-icon" (click)="sendFeedback()"
            title="Contact the team to leave feedback and report issues">feedback</mat-icon>
            <mat-icon [matMenuTriggerFor]="menu" class="person-icon">person</mat-icon>
          </div>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="userinfo()">My Profile</button>
            <button mat-menu-item (click)="whatsnew()">What's New?</button>
            @if (this.UserIsSystemAdmin) {
              <button mat-menu-item (click)="about()">About {{this.SiteName}}</button>
            }
            <button mat-menu-item (click)="logOut()">LOG OUT</button>
            @if (!doingImpersonation()) {
              @for (user of impersonatableUsers; track user) {
                <button mat-menu-item (click)="impersonate(user.mfUserid)"
                  title="{{user.displayName}}">
                  Impersonate {{user.displayName}}
                </button>
              }
            }
            @if (doingImpersonation()) {
              <button mat-menu-item (click)="stopImpersonating()">
                Stop Impersonating
              </button>
            }
          </mat-menu>
        }
      </div>
    }
  </div>
}
